function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var duration = 0;

var ts2sec = function ts2sec(ts) {
  var _ts$split = ts.split(':'),
      _ts$split2 = _slicedToArray(_ts$split, 3),
      h = _ts$split2[0],
      m = _ts$split2[1],
      s = _ts$split2[2];

  return parseFloat(h) * 60 * 60 + parseFloat(m) * 60 + parseFloat(s);
};

module.exports = function (_ref, progress) {
  var message = _ref.message;

  if (typeof message === 'string') {
    if (message.startsWith('  Duration')) {
      var ts = message.split(', ')[0].split(': ')[1];
      var d = ts2sec(ts);

      if (duration === 0 || duration > d) {
        duration = d;
      }
    } else if (message.startsWith('frame')) {
      var _ts = message.split('time=')[1].split(' ')[0];
      var t = ts2sec(_ts);
      progress({
        ratio: t / duration
      });
    } else if (message.startsWith('video:')) {
      progress({
        ratio: 1
      });
    }
  }
};